module.exports = __webpack_public_path__ + "img/4.845328fb.png";